document.querySelectorAll('[data-retail-product]').forEach(root => {
  if (root.dataset.retailReady) return;
  root.dataset.retailReady = 'true';
  const select = root.querySelector('[data-retail-variant]');
  const image = root.querySelector('.vr-retail__image');
  const price = root.querySelector('[data-retail-price]');
  const button = root.querySelector('button[type="submit"]');
  const update = () => {
    const option = select.selectedOptions[0];
    button.disabled = !select.value || option.disabled;
    if (!select.value) return;
    price.textContent = option.dataset.price;
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.alt || root.querySelector('h1').textContent;
    }
  };
  select.addEventListener('change', () => {
    update();
    const url = new URL(location.href);
    if (select.value) url.searchParams.set('variant', select.value);
    else url.searchParams.delete('variant');
    history.replaceState(null, '', url);
  });
  update();
});